// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_Oaf","cls2":"CourseResults-cls2_1Ao CourseResults-cls1_Oaf"};